import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ExecutionModuleProvider } from '../modules/execution/context/ExecutionModuleContext';
import { ExecutionHubPage, ExecutionInstanceModulePage } from '../modules/execution/pages/ExecutionHubPage';

/**
 * Hub central de execucoes, tarefas e kanban operacional.
 */
export const WorkflowPage: React.FC = () => {
  return (
    <ExecutionModuleProvider>
      <Routes>
        <Route index element={<Navigate to="instancias" replace />} />
        <Route path="instancias/:id" element={<ExecutionInstanceModulePage />} />
        <Route path="*" element={<ExecutionHubPage />} />
      </Routes>
    </ExecutionModuleProvider>
  );
};
